module.exports = __webpack_public_path__ + "img/c03_unitmerchanttransport_Normal_ua.1e78ab5d.webp";